import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

// Define writingItems directly in the component file
// Writing Items
const writingItems = [
    {
      id: 9,
      image: require("../images/latest-writing/news-9.jpg"),
      name: "PV60",
      date: "29 July 2023",
      description: `
  <p>PREMIER is the largest exporter of Liquid Ring Vaccuum Pumps and Spares with installations in more than forty countries.</p>
  `
    },
  
  
  
  
    {
      id: 3,
      image: require("../images/latest-writing/news-3.jpg"),
      name: "PV60",
      date: "16 November 2024",
      description: `
  <p>PREMIER make P501 M pump equivalent to NASH 904 M arrives in a paper mill in the U.S.A</p>
  <p>Contact PREMIER for your emergency requirements to replace your existing O.E.M Vacuum Pumps and spares.</p>
  `
    },
  
    {
      id: 2,
      image: require("../images/latest-writing/news-7.jpeg"),
      name: "PV60",
      date: "09 January 2025",
      description: `
  <p>PREMIER offers its unique performance evaluation services for Liquid Ring Vacuum Pumps with minimum pump shutdown time, giving in time failure predictions and minimizing plant shutdown costs due to pump failure.</p>
  `
    },
  
  
  ];
  // Writing Items

function WritingDetails() {
    const location = useLocation();
    const navigate = useNavigate();
    const { id } = useParams(); // Get the id from the URL

    // Use state from location or find item by id
    const { name, date, description, image, id: stateId } = location.state || {};
    const currentItem = writingItems.find((item) => item.id === parseInt(id)) || {};
    const displayItem = name && description ? { name, date, description, image, id: stateId } : currentItem;

    // Find the current item's index in the writingItems array
    const currentIndex = writingItems.findIndex((item) => item.id === parseInt(id));

    const handlePrevious = () => {
        if (currentIndex > 0) {
            const prevItem = writingItems[currentIndex - 1];
            navigate(`/writing-details/${prevItem.id}`, { state: prevItem });
        }
    };

    const handleNext = () => {
        if (currentIndex < writingItems.length - 1) {
            const nextItem = writingItems[currentIndex + 1];
            navigate(`/writing-details/${nextItem.id}`, { state: nextItem });
        }
    };

    if (!displayItem.name || !displayItem.description || currentIndex === -1) {
        return (
            <div className="writing-details-section py-5">
                <div className="container">
                    <h1 className="fw-bold mb-4 text-blue">Content Not Found</h1>
                    <p className="text-dark lead">No writing details available.</p>
                    <a href="/latest-writing" className="btn btn-outline-primary mt-3">
                        Back to Latest Writing
                    </a>
                </div>
            </div>
        );
    }

    return (
        <div>
            <div className="writing-details-section py-5">
                <div className="container">
                    <div className="row justify-content-center p-4">
                        <div className="col-lg-10">
                            <img
                                src={displayItem.image}
                                alt={displayItem.name}
                                className="img-fluid mb-4 rounded-20"
                                style={{ maxWidth: '100%', height: 'auto' }}
                            />
                            {/* <p className="card-text text-muted text-blue">{displayItem.date}</p> */}
                            <div className="description-content">
                                <p
                                    className="product-capacity jost-font text-start text-dark lead fs-5"
                                    dangerouslySetInnerHTML={{ __html: displayItem.description }}
                                />
                            </div>
                            <div className="d-flex justify-content-end mt-4">
                                <button
                                    className="btn btn-outline-primary me-2 prev1 px-4 py-0 fs-5"
                                    onClick={handlePrevious}
                                    disabled={currentIndex <= 0}
                                >
                                    ‹
                                </button>
                                <button
                                    className="btn btn-outline-primary next1 px-4 py-0 fs-5"
                                    onClick={handleNext}
                                    disabled={currentIndex >= writingItems.length - 1}
                                >
                                    ›
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default WritingDetails;